export default {
  dataIterator: {
    rowsPerPageText: 'Predmetov na stran:',
    rowsPerPageAll: 'Vse',
    pageText: '{0}-{1} od {2}',
    noResultsText: 'Ni iskanega zapisa',
    nextPage: 'Naslednja stran',
    prevPage: 'Prejšnja stran'
  },
  dataTable: {
    rowsPerPageText: 'Vrstic na stran:'
  },
  noDataText: 'Ni podatkov',
  carousel: {
    prev: 'Prejšnji vizualni prikaz',
    next: 'Naslednja vizuala'
  }
}
